export default __webpack_public_path__ + "media/images/logos/logo_dark-c711eaa378dd07cbdbf00acbf171b8c6.png";